<style lang="less" rel="stylesheet/less" scope>
  .cascader{
    .el-cascader--small {
      width: 100%;
    }
    .el-cascader--small .el-cascader__label {
      line-height: 38px;
    }
  }
</style>
<template>
  <div class="cascader">
    <el-cascader
      expand-trigger="click"
      :show-all-levels="false"
      change-on-select
      :options="cascaderData"
      v-model="selectedOptions"
      :props="defaultProps"
      size="small"
      placeholder="请选择上级机构"
      clearable
      @change="handleChange">
    </el-cascader>
  </div>
</template>
<script type='text/ecmascript-6'>
  import { getPathById, getCheckNode } from '@/api/tree'
  import { getTree } from '@/api/tree'

  export default {
    name: 'LyTreeCascader',
    props: {
      value: {
        type: String,
        default: ''
      },
      isGetNode: { // 是否需要返回选中数据
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      path: [],
      cascaderData: [],
      selectedOptions2: '',
      inputHover: false,
      option: '',
      selectedOptions: [],
      defaultProps: {
        value: 'id',
        label: 'name',
        children: 'children',
      },
    }),
    created() {
      this.getTreeList();
    },
    mounted() {

    },
    methods: {
      handleChange(val) {
        let _val = Object.assign({},val);
        let id = Object.values(_val).pop();
        this.$emit('cascaderParams', id);
        this.getCascaderNode(id);
      },
      getTreeList() {
        getTree().then(res => {
          this.cascaderData = [res.data];
        }).then(() => {
          getPathById(this.value, this.cascaderData[0], (arr) => {
            this.selectedOptions = arr;
          });
          this.getCascaderNode(this.value);
        })
      },
      getCascaderNode(id) {
        if (this.isGetNode) {
          getCheckNode(id, this.cascaderData[0], (node) => {
            this.$emit('cascaderNode', node);
          })
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/tree-cascader/index.vue